// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import surveyQuestionEntity from './entities/survey-question.json';
import surveyQuestionMenu from '../pages/survey-question/menu.json';
import surveyQuestionFullForm from '../pages/survey-question/forms/full.json';
import surveyQuestionContextForm from '../pages/survey-question/forms/context.json';
import surveyQuestionMiniForm from '../pages/survey-question/forms/mini.json';
import surveyQuestionLookupForm from '../pages/survey-question/forms/lookup.json';
import surveyQuestionTableView from '../pages/survey-question/views/table.json';
import surveyQuestionCardsView from '../pages/survey-question/views/cards.json';
import surveyQuestionDashboardView from '../pages/survey-question/views/dashboard.json';

/** Тип запису «Питання опитування» зі сторінками пакета: меню, форми та подання з pages/survey-question/. */
export const surveyQuestionDefinition: IRecordTypeDefinition = {
  ...surveyQuestionEntity,
  views: assembleViewSet({
      table: surveyQuestionTableView,
      cards: surveyQuestionCardsView,
      dashboard: surveyQuestionDashboardView,
  }),
  form: surveyQuestionFullForm,
  forms: { full: surveyQuestionFullForm, context: surveyQuestionContextForm, mini: surveyQuestionMiniForm, lookup: surveyQuestionLookupForm },
  menu: surveyQuestionMenu,
} as IRecordTypeDefinition;
